<!--
 * @Author: wanglibo
 * @LastEditors: wanglibo
 * @Description: 营养门诊-患者基础信息
 * @step 1: 入口 2: 基础信息 3: 身体信息 4: NRS2002 5: 饮食习惯  6: 营养认知 7: 健康行为 8: 健康评估 9: 营养改进 10: 营养评估结果
-->

<template>
  <div class="page-content" ref="scrollContainer">
    <FormEntry @next-step="nextStep" v-if="step === 1" />
    <BaseInfo @next-step="nextStep" @prev-step="prevStep" :initData="baseInfo" v-if="step === 2" />
    <BodyInfoEntry @next-step="nextStep" @prev-step="prevStep" :initData="sourceInbodyData" v-if="step === 3" />
    <BodyInfoForm @next-step="nextStep" @prev-step="prevStep" :baseInfo="baseInfo" :initData="sourceInbodyData" v-if="step === 4" />
    <Nrs2002Form @next-step="nextStep" @prev-step="prevStep" :initData="nrs2002Form" v-if="step === 5" />
    <DietaryHabits @next-step="nextStep" @prev-step="prevStep" :initData="dietaryHabits" v-if="step === 6" />
    <NutritionalAwareness @next-step="nextStep" @prev-step="prevStep" :initData="nutritionalAwareness"
      v-if="step === 7" />
    <HealthBehavior @next-step="nextStep" @prev-step="prevStep" :initData="healthBehavior" v-if="step === 8" />
    <HealthAssess :pastMedicalDict="pastMedicalDict" :pastMedicalDictChild="pastMedicalDictChild" @next-step="nextStep" @prev-step="prevStep"
      :initData="healthAssess" :baseInfo="baseInfo" v-if="step === 9" />
    <DietaryImprovement @next-step="nextStep" @prev-step="prevStep" :initData="dietaryImprovement" v-if="step === 10" />
    <NutritionalScreenAssessResult v-if="step === 11" @next-step="nextStep" @prev-step="prevStep"
      :initData="nutritionalScreenAssessResult" :id="id" :doctorId="doctorId" />
  </div>
</template>

<script>
import uuid from 'uuid';
import { Toast } from 'vant';
import ajax from '@/api/ajax';
import { getQueryString } from '@/api/restapi';
import ClinicApi from '@/api/clinicApi.js';
import FormEntry from './components/FormEntry.vue';
import BaseInfo from './components/BaseInfo.vue';
import BodyInfoEntry from './components/BodyInfoEntry.vue';
import BodyInfoForm from './components/BodyInfoForm.vue';
import DietaryHabits from './components/DietaryHabits.vue';
import DietaryImprovement from './components/DietaryImprovement.vue';
import Nrs2002Form from './components/Nrs2002Form.vue';
import NutritionalAwareness from './components/NutritionalAwareness.vue';
import HealthBehavior from './components/HealthBehavior.vue';
import HealthAssess from './components/HealthAssess.vue';
import NutritionalScreenAssessResult from "./components/NutritionalScreeAssessResult";

export default {
  name: 'ClinicIndex',
  components: {
    FormEntry, BaseInfo, BodyInfoEntry, BodyInfoForm, DietaryHabits, Nrs2002Form, NutritionalAwareness, HealthBehavior, HealthAssess, DietaryImprovement, NutritionalScreenAssessResult
  },
  data() {
    return {
      pastMedicalDict: [],//过往病史字典
      pastMedicalDictChild:[],//过往病史子级字典
      step: 1,
      id: "",
      dataId: "",
      toast: '',
      doctorId: "",
      baseInfo: {},
      bodyType:'',
      inbodyData: {},
      sourceInbodyData: {},
      dietaryHabits: {},
      nrs2002Form: {},
      healthBehavior: {},
      healthAssess: {},
      nutritionalScreenAssessResult: {},
      nutritionalAwareness: {},
    }
  },
  created() {
    document.title = '智能营养师';
    this.doctorId = getQueryString('doctorId') || this.doctorId
  },
  mounted() {
    this.selectPastMedicalDict()
    // this.queryResult();
  },
  watch: {
    // 监听路由变化
    '$route.query.clearCache': {
      handler(newVal) {
        console.log('clearCache', newVal)
        if (newVal) {
          this.clearAndReload();
        }
      },
      immediate: true
    }
  },
  methods: {
    async clearAndReload() {
      this.loading = true;
      try {
        // 清除本地缓存
        this.step=1
        this.baseInfo = {},
          this.inbodyData = {},
          this.sourceInbodyData = {},
          this.dietaryHabits = {},
          this.nrs2002Form = {},
          this.healthBehavior = {},
          this.healthAssess = {},
          this.nutritionalScreenAssessResult = {},
          this.nutritionalAwareness = {},
          this.$message.success('缓存已更新');
      } catch (error) {
        console.error('加载失败', error);
      } finally {
        this.loading = false;
      }
    },
    // 查询过往病史字典
    selectPastMedicalDict() {
      ClinicApi.selectPastMedicalDict().then(({ data }) => {
        if (data.success) {
          this.pastMedicalDict = data.data;
          this.pastMedicalDictChild = this.pastMedicalDict[1]?.children || []
        } else {
          this.$toast(data.message || '查询过往病史字典失败');
        }
      })
    },
    getRecordId() {
      ClinicApi.generateId({ doctorId: this.doctorId }).then(({ data }) => {
        if (data.success) {
          this.id = data.data;
          this.step++;
        } else {
          this.$toast(data.message || '生成记录id失败');
        }
      })
    },
    prevStep() {
      console.log('prevStep', this.step);
      if(this.step === 5 && this.bodyType==3){
        this.step--;
        this.step--;
      }else{
        this.step--;
      }
      this.scrollToTop();
    },
    nextStep({ type, data }) {
      switch (type) {
        case 'formEntry':
          this.getRecordId();
          break;
        case 'bodyInfoEntry':
          this.bodyType = data.bodyType;
          if (data.bodyType == '1') {
            this.url = data.url;
            this.dataId = uuid.v4();
            this.content = ""
            this.sourceInbodyData = {};
            this.inbodyData = {};
            Toast.loading({
              duration: 0, // 持续展示 toast
              forbidClick: true,
              message: '数据解析中',
            });
            this.toConnect();
          } else if (data.bodyType === '3') {
            this.step++;
            this.step++
          } else {
            this.sourceInbodyData = {
              body_fat_reference_range: "   ~",
              body_protein_reference_range: "   ~",
              total_body_water_reference_range: "   ~"
            };
            this.step++;
          }

          break;
        case 'baseInfo':
          this.baseInfo = data;
          this.step++;
          break;
        case 'inbodyData':
          this.inbodyData = data;
          this.step++;
          break;
        case 'dietaryHabits':
          this.dietaryHabits = data;
          this.step++;
          break;
        case 'nrs2002Form':
          this.nrs2002Form = data;
          this.step++;
          break;
        case 'healthBehavior':
          this.healthBehavior = data;
          this.step++;
          break;
        case 'healthAssess':
          this.healthAssess = data;
          this.step++;
          break;
        case 'nutritionalAwareness':
          this.nutritionalAwareness = data;
          this.step++;
          break;
        case 'dietaryImprovement':
          this.dietaryImprovement = data;
          this.SubmitSave();
          break;
        case 'nutritionalScreenAssessResult':
          this.$router.push({
            path: '/clinic/index',
            query: {
              doctorId: this.doctorId,
              id: this.id,
              clearCache: true
            }
          })
          break;
        default:
          break;
      }
      this.scrollToTop();
    },
    SubmitSave() {
      // addType  添加方式 1：PAD端添加 2：扫码添加
      let params = {
        id: this.id,
        addType: 1,
        url:this.url,
        doctorId: this.doctorId,
        ...this.baseInfo,
        inbody: {
          sourceInbodyData: this.sourceInbodyData,
          inbodyData: this.inbodyData,
        },
        screenAssessment: {
          ...this.dietaryHabits,
          ...this.nrs2002Form,
          ...this.healthBehavior,
          ...this.healthAssess,
          ...this.nutritionalAwareness,
          ...this.dietaryImprovement,
        },

      }
      console.log('SubmitEvent', this)
      ClinicApi.addNrsAndAssessmentRecord({
        id: this.id,
        ...params
      }).then(({ data }) => {
        if (data.success) {
          // this.$toast('保存成功');

          this.queryResult();
        } else {
          this.$toast(data.message || '保存失败');
        }
      })
    },
    queryResult() {
      ClinicApi.searchNrsAndAssessmentRecordById({
        id: this.id
      }).then(({ data }) => {
        if (data?.success) {
          let postDiseaseName = this.pastMedicalDict.find(item => item.id == data.data.screenAssessment.healthZpJtqzjb)
          this.nutritionalScreenAssessResult = {
            ...data.data,
            postDiseaseName: postDiseaseName?.name || ''
          };
          this.step++;
        } else {
          this.$toast(data.message || '查询失败');
        }
      })
    },
    toConnect() {

      if (this.eventSource) {
        this.eventSource.close();
      }
      // 创建 SSE 连接
      this.eventSource = new EventSource(`/api/ai/hlxj/sse/connected?clientId=${this.baseInfo.phone}`);

      // 监听服务器发送的消息
      this.eventSource.onmessage = this.handleEventMessage

      // 监听自定义事件
      this.eventSource.addEventListener('customEvent', (event) => {
        console.log('customEvent', event.data);
        this.messages.push(`Custom Event: ${event.data}`);
      });

      // 处理错误
      this.eventSource.onerror = (error) => {
        console.error('SSE error:', error);
        this.eventSource.close();
      };
      setTimeout(() => {
        this.getContent()
      }, 200);
    },
    closeCon() {
      this.loadStatus = 2;
      this.eventSource.close();
    },
    closeConnect() {
      if (this.eventSource) {
        // this.closeLoading()
        Toast.clear();
        this.eventSource.close();  // 关闭 EventSource 连接
        // this.contentBuffer = "";
        // this.currentId = null;
        this.dataId = null;
        this.loading = false

      }
      ajax.Get({
        url: `/ai/hlxj/sse/closeConnect?clientId=${this.baseInfo.phone}`
      }).then(res => {
        if (res.status >= 200 && res.status < 300) {
          console.log('SSE连接已关闭');
          this.loadStatus = true
        } else {
          console.error('关闭SSE连接失败:', res.statusText);
        }
      })


    },
    getContent() {
      this.loadStatus = 1;
      ajax
        .Post({
          url: '/api/ai/hlxj/sse/parseFastGptPhotoReader',
          data: {
            prompt: this.url,
            chatId: this.baseInfo.phone,
            dataId: this.dataId,
            chatType: 'inbody'
          }
        }).then((res) => {
          if (res.status == 200) {
            console.log("成功", res)

          } else {
            console.log("失败", res.data)
            Toast.clear();
          }
        })
    },
    handleEventMessage(event) {
      let data = JSON.parse(event.data);
      console.log('Received data:', event.data, JSON.parse(event.data));
      if (data.event === 'finishedEnd') {
        console.log("回答完成", this.content,)
        let sourceInbodyData = this.content && JSON.parse(this.content) || {};
        this.inbodyData = {};
        this.sourceInbodyData = { ...sourceInbodyData };
        this.baseInfo.weight = sourceInbodyData?.weight;
        this.baseInfo.height = sourceInbodyData?.height;
        this.step++;

        if (this.eventSource) {
          this.closeConnect();  // 关闭 EventSource 连接
        }
        // setEventSource(null);  // 清空保存的实例
        return
      }

      let modifiedData = data.choices[0].delta.content;
      console.log("modifiedData", modifiedData)
      this.content = modifiedData ? this.content + modifiedData : this.content
      // this.scrollToBottom();
    },
    scrollToTop() {
      const container = this.$refs.scrollContainer;
      container.scrollTop = 0;
    },
  },

};
</script>

<style scoped>
html {
  font-size: 24px;
}

div,
p,
ul,
li,
* {
  box-sizing: border-box;
}
.page-content {
  height: 100vh;
  overflow: auto;
  background-color: #fff;
}
</style>